// extracted by mini-css-extract-plugin
module.exports = {"modal":"Error_modal__2g-Cq","row":"Error_row__faAp5","button":"Error_button__3B9rA","message":"Error_message__3UDxa"};